import { Backdrop, CircularProgress } from "@mui/material";
import useLoadingBackdrop from "../../common/hooks/useLoadingBackdrop";

export function LoadingBackdrop() {
  const { loading } = useLoadingBackdrop();

  return (
    <Backdrop
      sx={{ color: "common.white", zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={loading}
      onClick={() => {
        // Do nothing
      }}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
}
